import React from 'react';
import cs from 'classnames';
import { Typography } from '@forgeglobal/design-framework';
import { useStyles } from '@tcs/client-portal-common/components/molecules/Table/style';
interface CellProps {
  primary: string;
  secondary?: string;
  align?: 'left' | 'right';
  isPrivate?: boolean;
  isPending?: boolean;
}

const TwoLineCell = ({
  primary,
  secondary,
  align = 'left',
  isPrivate = false,
  isPending = false, // see AccountsTransactionsTable for usage of pending rows
}: CellProps) => {
  const classes = useStyles({ secondaryLine: !!secondary });

  return (
    <div
      data-private={isPrivate || null}
      className={cs(classes.baseCell, classes.twoLine, {
        [classes.rightAlign]: align === 'right',
      })}
      title={`${primary} ${secondary ?? ''}`}>
      <Typography variant="body1" className={classes.cellText}>
        {primary}
      </Typography>
      {secondary && (
        <>
          <Typography
            variant="body2"
            color={isPending ? 'inherit' : 'textSecondary'}
            className={cs(classes.cellText, classes.onlyDesktop)}>
            {secondary}
          </Typography>
          <Typography
            variant="body1"
            color={isPending ? 'inherit' : 'textSecondary'}
            className={cs(classes.cellText, classes.onlyMobile)}>
            {secondary}
          </Typography>
        </>
      )}
    </div>
  );
};

export default TwoLineCell;
